var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoursquareCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.58,
    height: 10.935,
    viewBox: "0 0 14.58 10.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff6900;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,70.376l4.993,5L14.58,65.8,13.2,64.443l-8.211,8.2L1.357,69.009Z",
    transform: "translate(0 -64.443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoursquareCheckIn);
export default __webpack_public_path__ + "static/media/foursquare-check-in.a220bd103ee869aa2131d61ec620feab.svg";
export { ForwardRef as ReactComponent };